import { create } from 'zustand'

const useDesignStore = create((set) => ({
  opportunities_and_challenges: [
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
  ],
  setField: (field, value) => set((state) => ({ ...state, [field]: value })),
  init: () =>
    set((state) => ({
      ...state,
      opportunities_and_challenges: [
        {
          isLoading: true,
        },
        {
          isLoading: true,
        },
        {
          isLoading: true,
        },
      ],
    })),
}))

export default useDesignStore
